import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '../../general/Input/Input';
import Button from '../../general/Button/Button';

import './ConfirmationPopup.css';

const ConfirmationPopup = ({ onClose, onConfirm }) => {
    const [inputValue, setInputValue] = useState('');
    const [isInputValid, setIsInputValid] = useState(false);


    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value.toLowerCase() === 'excluir') {
            setIsInputValid(true);
        } else {
            setIsInputValid(false);
        }
    };

    const handleConfirm = () => {
        if (isInputValid) {
            onConfirm(); 
        } else {
            alert('Por favor, digite "excluir" para confirmar a ação.');
        }
    };

    return (
        <div className="confirmation-overlay">
            <div className="confirmation-popup">
                <h3 className="confirmation-title">Tem certeza que deseja excluir?</h3>
                <p className="confirmation-subtitle">
                    Para confirmar a exclusão permanente, digite <span className="confirmatn-word">'excluir'</span> no campo abaixo.
                </p>

                <Input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    className={`confirmation-input ${!isInputValid ? 'input-error' : ''}`}
                    placeholder="Digite excluir para confirmar."
                    aria-label="Digite excluir para confirmar."
                />

                <div className="confirmation-buttons">
                    <Button 
                        type="submit" 
                        variant="delete" 
                        className='btn-delete' 
                        onClick={handleConfirm}
                        disabled={!isInputValid}>
                        Excluir
                    </Button>

                    <Button 
                        type="submit" 
                        variant="cancel" 
                        className='btn-cancel' 
                        onClick={onClose}>
                        Cancelar
                    </Button>
                </div>
            </div>
        </div>
    );
};

ConfirmationPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationPopup;
